import { useEffect, useState } from "react";
import { FormControl, Grid, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import OrderTable from "../components/OrderTable";
import { sortOrder } from "../utils/Constants";
import Page from "../components/Controls/Page";
import { BaseAPI } from "../utils/Api";
import { getItem } from "../utils/Helper";
import ErrorHandler from "../utils/ErrorHandler";
import Notification from "../utils/Notification";
import LoadingState from "../components/Controls/LoadingState";

const Orders = () => {
  const navigate = useNavigate();

  const [age, setAge] = useState("");
  const [loading, setLoading] = useState(false);
  const [orderList, setOrderList] = useState([]);

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  useEffect(() => {
    setLoading(true);
    BaseAPI.get("/order", { headers: { Authorization: `Bearer ${getItem(localStorage, "at")}` } })
      .then((res) => {
        console.log(res.data.data);
        setOrderList(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          ErrorHandler(err?.response?.data?.message, navigate);
        } else {
          Notification("Something went wrong! Please check your internet", "error");
        }
      })
      .finally(() => setLoading(false));

    return () => {
      setOrderList([]);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page title='Orders'>
      <LoadingState loading={loading} />
      <Typography variant='h4' mt={2} mb={4} className='bold'>
        My Orders
      </Typography>
      <Grid container direction='row' justifyContent='flex-end' alignItems='center' spacing={2}>
        <Grid>
          <FormControl sx={{ m: 1, minWidth: 150 }} size='small'>
            <InputLabel id='demo-simple-select-label'>Sort by status</InputLabel>
            <Select labelId='demo-simple-select-label' id='demo-simple-select' value={age} label='Sort by status' onChange={handleChange}>
              {sortOrder.map((el, i) => (
                <MenuItem value={el.value} key={i}>
                  {el.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <OrderTable info={orderList} />
    </Page>
  );
};

export default Orders;
